import { BrokerOfferModule } from './types/BrokerOfferModule';
import { Module as RentModuleType } from './types/RentModels';
import { Module } from './types/SaleModels';

export const getNameFromSaleModule = (module: Module) => {
    switch (module) {

    case Module.SALE_HOUSE:
        return 'Dom';
    case Module.SALE_PLOT:
        return 'Działka';
    case Module.SALE_OTHER:
        return 'Inne';
    case Module.SALE_FLAT:
    default:
        return 'Mieszkanie';

    }
};

export const getNameFromModule = (module: RentModuleType | Module): string => {
    switch (module) {
    case RentModuleType.RENT_HOUSE:
    case Module.SALE_HOUSE:
        return 'Dom';
    case RentModuleType.RENT_PLOT:
    case Module.SALE_PLOT:
        return 'Działka';
    case RentModuleType.RENT_OTHER:
    case Module.SALE_OTHER:
        return 'Inne';
    case RentModuleType.RENT_FLAT:
    case Module.SALE_FLAT:
    default:
        return 'Mieszkanie';
    }
};

export const getNameFromBrokerModule = (module: BrokerOfferModule): string => {
    switch (module) {
    case BrokerOfferModule.OFFER_SALE_HOUSE:
    case BrokerOfferModule.OFFER_RENT_HOUSE:
        return 'Dom';
    case BrokerOfferModule.OFFER_SALE_PLOT:
    case BrokerOfferModule.OFFER_RENT_PLOT:
        return 'Działka';
    case BrokerOfferModule.OFFER_SALE_OTHER:
    case BrokerOfferModule.OFFER_RENT_OTHER:
        return 'Inne';
    case BrokerOfferModule.OFFER_SALE_FLAT:
    case BrokerOfferModule.OFFER_RENT_FLAT:
    default:
        return 'Mieszkanie';
    }
};
